import { ISiteDataConnectSettingsForSiteAdmin } from '~src/settings/types/ISiteAdminDataConnectSettings';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IGetSiteDataConnectSettingsForSiteAdminParams {

}

export type IGetSiteDataConnectSettingsForSiteAdminResult = IResult & ISiteDataConnectSettingsForSiteAdmin;

export class GetSiteDataConnectSettingsForSiteAdminRequest
  extends Request<IGetSiteDataConnectSettingsForSiteAdminParams, IGetSiteDataConnectSettingsForSiteAdminResult>
{
  constructor(params: IGetSiteDataConnectSettingsForSiteAdminParams) {
    super('getSiteDataConnectSettingsForSiteAdmin', params);
  }
}
